import Axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import qs from 'qs';
import { API_URL } from '../config';
import { getToken } from '../utils/auth0';

const getAccessToken = () => {
  return localStorage.getItem('token');
};

const setAccessToken = (token) => {
  localStorage.setItem('token', token);
};

const axios = () => {
  const client = Axios.create({
    baseURL: API_URL,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false, encode: true });
    },
  });

  const refreshToken = async (failedRequest) => {
    const token = await getToken();
    setAccessToken(token);
    // eslint-disable-next-line no-param-reassign
    failedRequest.response.config.headers.Authorization = `Bearer ${token}`;
  };

  createAuthRefreshInterceptor(client, refreshToken, {
    statusCodes: [401, 403],
  });

  client.interceptors.request.use((request) => {
    request.headers.Authorization = `Bearer ${getAccessToken()}`;
    return request;
  });

  return client;
};

export default axios();
